module.exports = __webpack_public_path__ + "img/m-banner-cookagaw-en-US.e58b4af9.jpg";